/**
 * Meet The Team Component
 * Humanizing the brand with personality and trust
 */

import React, { useState } from 'react';

interface TeamMember {
  id: string;
  name: string;
  role: string;
  image?: string;
  emoji: string;
  specialties: string[];
}

const teamMembers: TeamMember[] = [
  {
    id: 'dr-machek',
    name: 'Dr. Machek',
    role: 'Veterinarian',
    image: '/team/Dr. Machek.png',
    emoji: '👩‍⚕️',
    specialties: [],
  },
  {
    id: 'dr-heller',
    name: 'Dr. Heller',
    role: 'Veterinarian and Co-Founder',
    image: '/team/Dr. Andrew Heller.jpeg',
    emoji: '👨‍⚕️',
    specialties: [],
  },
  {
    id: 'anna-stryjek',
    name: 'Anna',
    role: 'Lead Veterinary Technician',
    image: '/team/Anna Stryjek Vet Tech.jpeg',
    emoji: '👩‍🔬',
    specialties: [],
  },
  {
    id: 'sarah-george',
    name: 'Sarah',
    role: 'Veterinary Technician',
    image: '/team/Sarah George Vet Tech.jpeg',
    emoji: '👨‍🔬',
    specialties: [],
  },
  {
    id: 'stacey',
    name: 'Stacey',
    role: 'Community',
    image: '/team/Stacey.png',
    emoji: '👩',
    specialties: [],
  },
  {
    id: 'tom',
    name: 'Tom',
    role: 'Tech Support',
    image: '/team/Tom.png',
    emoji: '👨‍💻',
    specialties: [],
  },
  {
    id: 'samson',
    name: 'Samson',
    role: 'Our Beautiful Blind Bouvier',
    image: '/team/Samson.png',
    emoji: '🐕',
    specialties: [],
  },
];

const MeetTheTeam: React.FC = () => {
  const [activeMember, setActiveMember] = useState<string | null>(null);
  const [hoveredMember, setHoveredMember] = useState<string | null>(null);

  return (
    <section className="section-padding bg-gradient-to-br from-warm-50 via-white to-teal-50 overflow-hidden">
      <div className="container-custom">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block bg-brand-teal/10 text-brand-teal px-4 py-1 rounded-full text-sm font-bold mb-4">
            <i className="fas fa-heart mr-2"></i>
            THE HUMANS BEHIND CHOMP
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-primary mb-4 font-nantes">
            Meet Our Team
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Veterinary dental specialists dedicated to your pet's health
          </p>
        </div>

        {/* Team Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {teamMembers.map((member) => (
            <div
              key={member.id}
              className={`relative bg-white rounded-3xl p-6 transition-all duration-500 cursor-pointer ${
                activeMember === member.id
                  ? 'shadow-2xl scale-105 z-10'
                  : hoveredMember === member.id
                  ? 'shadow-xl scale-102'
                  : 'shadow-lg hover:shadow-xl'
              }`}
              onClick={() => setActiveMember(activeMember === member.id ? null : member.id)}
              onMouseEnter={() => setHoveredMember(member.id)}
              onMouseLeave={() => setHoveredMember(null)}
            >
              {/* Photo - 2x bigger */}
              <div className="relative mb-4">
                <div className="w-64 h-64 mx-auto rounded-full overflow-hidden shadow-lg">
                  {member.image ? (
                    <img 
                      src={member.image} 
                      alt={member.name}
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <div className="w-full h-full bg-gray-200 flex items-center justify-center text-8xl">
                      {member.emoji}
                    </div>
                  )}
                </div>
              </div>

              {/* Name & Role */}
              <div className="text-center">
                <h3 className="text-lg font-bold text-gray-800">{member.name}</h3>
                <p className="text-sm text-brand-teal font-medium">{member.role}</p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default MeetTheTeam;

